import { render, staticRenderFns } from "./InspectionsOverview.vue?vue&type=template&id=63bb867e&scoped=true&"
import script from "./InspectionsOverview.vue?vue&type=script&lang=ts&"
export * from "./InspectionsOverview.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionsOverview.vue?vue&type=style&index=0&id=63bb867e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bb867e",
  null
  
)

export default component.exports